export default __webpack_public_path__ + "static/media/02.d19a4b04.svg";